import { defineMessages } from "react-intl";

/**
 * Section copy. Anything naming a tax type takes it as `{taxType}` rather than
 * baking "VAT" in, so one string covers every region — see
 * `getTaxTypeName` in `TaxDetails.utils.ts` for the value that lands in
 * the placeholder.
 */
const TAX_DETAILS_MESSAGES = defineMessages({
  sectionHeading: {
    id: "tax_details.section_heading",
    defaultMessage: "Tax details",
  },
  registrationHeading: {
    id: "tax_details.registration_heading",
    defaultMessage: "{taxTypes} details",
  },
  taxId: {
    id: "tax_details.tax_id",
    defaultMessage: "{taxType} ID",
  },
  taxRate: {
    id: "tax_details.tax_rate",
    defaultMessage: "{taxType} %",
  },
  addOnsNote: {
    id: "tax_details.add_ons_note",
    defaultMessage:
      "If you have paid add-ons, please confirm which ones need {taxType} % added",
  },
  addOnsLink: {
    id: "tax_details.add_ons_link",
    defaultMessage: "here.",
  },
  removeHeading: {
    id: "tax_details.delete_modal.heading",
    defaultMessage: "Are you sure you want to remove your {taxType} details?",
  },
  removeBody: {
    id: "tax_details.delete_modal.body_copy",
    defaultMessage:
      "Without a {taxType} ID on file, you will not be {taxType} exempt from Peerspace fees.",
  },
  removeConfirm: {
    id: "tax_details.delete_modal.confirm",
    defaultMessage: "Remove {taxType}",
  },
  // Names a tax the fees API left unnamed; named ones are shown as it sends them.
  fallbackTaxTypeName: {
    id: "tax_details.tax_type_name.other",
    defaultMessage: "Sales tax",
  },
});

export { TAX_DETAILS_MESSAGES };
